<template>
  <div>
    <button class="btn-small solidgreen modal-trigger" :href="'#modal'+propertyProblemRow.device_id">{{$t('menu.buttons.edit')}}</button>
    <div :id="'modal'+propertyProblemRow.device_id" class="modal">
      <div class="modal-content">
        <h5>{{$t('inspection.editing_property')}} {{propertyProblemRow.number}}</h5>
        <div class="row">
          <div class="col s12">
            <fieldset style="border: none;">
               <label>
                <input :name="'mode'+uid" id="problem" value="property" type="radio" v-model="mode"/>
                <span>{{$t('inspection.property')}}</span>
              </label>
               <label>
                <input :name="'mode'+uid" id="property" value="problem" type="radio" v-model="mode"/>
                <span>{{$t('inspection.problem')}}</span>
              </label>
            </fieldset>
          </div>
        </div>
        <template v-if="problem != null">
         <div class="row">
            <div class="col s12">
              <fieldset>
                 <label>
                  <input :name="'not_found'+uid" id="not_found" value="1" type="radio" v-model="kind"/>
                  <span>{{$t('inspection.not_found')}}</span>
                </label>
                
                 <label>
                  <input :name="'unavailable'+uid" id="unavailable" value="3" type="radio" v-model="kind"/>
                  <span>{{$t('inspection.unavailable')}}</span>
                </label>
                 <label>
                  <input :name="'totaled'+uid" id="totaled" value="5" type="radio" v-model="kind"/>
                  <span>{{$t('inspection.destroyed')}}</span>
                </label>
                  <label>
                  <input :name="'temporary_disabled'+uid" id="temporary_disabled" value="6" type="radio" v-model="kind"/>
                  <span>{{$t('inspection.temporary_disabled')}}</span>
                </label>
              </fieldset>
            </div>
          </div>
          <div class="row">
            <div class="col s2"><button class="btn-small solidgreen" v-on:click="addPhoto()">{{$t('inspection.add_photo')}}</button></div>
          </div>
          <div class="row" style="margin-top: 25px;">
            <div class="col s2" v-for="(photo, index) in problem.media" v-if="photo._destroy != true" style="width: fit-content;margin: auto;height: 100px;">
              <button class="removephoto" v-on:click="removePhoto(photo)"><i class="material-icons">close</i></button>
              <div style="width: fit-content; margin: auto;">
                  <img style="max-height: 80px" v-if="photo.image" :src="photo.image" />
                  <img :class="'photo'+index" style="max-height: 80px" v-if="photo.image == undefined"/>
              </div>
              <p>{{photo.notices}}</p>
                <input
                  v-if="photo.image == undefined"
                  type="file"
                  id="photo"
                  name="photo"
                  multiple="true"
                  @change="setFile(photo, $event.target.name, $event.target.files)"
                  accept="image/png, image/jpeg"
               />
            </div>
          </div>
          <div class="row">
            <div class="col s12">
              <textarea v-model="inactivate_cause" :placeholder="$t('inspection.notices')"></textarea>
            </div>
          </div>
        </template>
        <template v-if="property != null">
          <inspector
            ref="inspector"
            v-bind:property="property" 
            :pestGroups="pestGroups" 
            :substanceGroups="substanceGroups" 
            :substanceUsages="substanceUsages" 
            :withSeal="withSeal" 
            :dev_type="dev_type"
            :criteria="criteria"
            :device="device"/>
        </template>
      </div>
      <div class="modal-footer">
        <button class="modal-close btn-small red">{{$t('menu.buttons.cancel')}}</button>
        <button class="modal-close btn-small solidgreen" v-on:click="apply()">{{$t('menu.buttons.save')}}</button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data: function() {
    return {
      long_act_levels: [this.$t('devices.no_activity'), this.$t('devices.low_activity'), this.$t('devices.average_activity'), this.$t('devices.high_activity'), this.$t('devices.very_high_activity')],
      device_conditions_levels: ["", this.$t('inspection.safety_conditions_broken'), this.$t('inspection.safety_conditions_need_replace'), this.$t('inspection.safety_conditions_good')],
      criteria_dict: {},
      criterium: {},
      device: {},
      dev_type: {},
      oldproblem: {
        kind: 1,
        inactivate_cause: ""
      },
      oldproperty: {},
      uid: _.uniqueId("deviceInspection"),
      substance_replaced: false,
      cleanup: false,
      conditions: 0,
      safety_conditions: 0,
      notices: "",
      substance_ids: [],
      property: null,
      problem: null,
      mode: null,
      kind: 1,
      inactivate_cause: ''
    }
  },
  watch:{
    'mode': {
       handler: function(newVal){
        if(newVal == 'problem'){
          this.problem ||= this.oldproblem;
          this.kind = this.problem.kind;
          this.inactivate_cause = this.problem.inactivate_cause;
          if(!_.isNil(this.property)){
            this.oldproperty = _.clone(this.property);
          }
          this.property = null;
        }else if(newVal == 'property'){
          if(!_.isNil(this.problem)){
            this.oldproblem = _.clone(this.problem);
          }
          this.problem = null;
          if(this.propertyProblemRow.conditions != undefined){
            this.property = this.propertyProblemRow;
            this.property.id = this.property.property_id;
          }else{
            var prop = {'conditions': 0, 'safety_conditions': 3, 'cleanup': true, 'substance_replaced': true};
            this.prepareProperty(prop)
          }
        }
       }
    }
  },
  props: {
    propertyProblemRow: Object, 
    pestGroups: Object, 
    substanceGroups: Object, 
    substanceUsages: Boolean, 
    withSeal: Boolean, 
    dev_types: Object,
    devices: Array,
    criteria: Array,
  },
  mounted() {
    var elemss = this.$el.querySelectorAll('.modal');
    this.instance = M.Modal.init(elemss, {});
    this.device = _.keyBy(this.devices,'id')[this.propertyProblemRow.device_id];
    this.dev_type = this.dev_types[this.device.dev_type_id];
    if(this.propertyProblemRow.conditions != undefined){
      var property = this.propertyProblemRow;
      property.id = this.propertyProblemRow.property_id;
      this.mode = 'property';
      this.prepareProperty(property)
    }else if(this.propertyProblemRow.kind != undefined){
      this.problem = this.propertyProblemRow;
      this.problem.id = this.propertyProblemRow.problem_id;
      this.mode = 'problem';
      this.kind = this.propertyProblemRow.kind;
      this.inactivate_cause = this.propertyProblemRow.inactivate_cause;
      this.problem.media = this.propertyProblemRow.problem_media || [];
    }
  },
  methods: {
    setgood(){
      this.good = true;
      this.$forceUpdate();
    },
    setbroken(){
      this.broken = true;
      this.$forceUpdate();
    },
    setneedreplace(){
      this.need_replace = true;
      this.$forceUpdate();
    },
    addPhoto(){
      this.problem.media.push({notices: ""});
      this.$forceUpdate();
    },
    prepareProperty(prop){
      if(prop != null){
        prop.method ||= this.propertyProblemRow.current_method;
        if(prop.method == 'pests_quantity'){
          prop.property_pests = [];
        }
        prop.dosages =  _.chain(this.device.last_dosage).map(
            obj => _.defaults({}, obj, {'replaced': 0, 'new_dose': 0, 'consumed': 0})
        ).value() || []
        for (var i = this.criteria.length - 1; i >= 0; i--) {
          var zone = this.criteria[i];
          this.criteria_dict[""+zone.zone_id]={};
          for (var j = zone.categories.length - 1; j >= 0; j--) {
            this.criteria_dict[""+zone.zone_id][zone.categories[j].id] = zone.categories[j];
          }
        }
        var crit = this.criteria_dict[""+this.device.zone_id] != undefined ? this.criteria_dict[""+this.device.zone_id][""+this.device.dev_category] : undefined;
        if(crit != undefined) prop.method = crit.method
        if(prop.method == 'pests_quantity') prop.property_pests = [];
        prop.maintenace_ids ||=  [];
        prop.consumed ||= 0.00;
        prop.media = this.propertyProblemRow.property_media || [];
        console.log(prop, crit);
        this.criterium = crit;
        this.property = prop;
      }
    },
    removePhoto(photo) {
        if (_.isUndefined(photo.id)) {
            this.media.splice(this.media.indexOf(photo), 1)
        } else {
            photo._destroy = true;
        }
         this.$forceUpdate();
    },
    apply(){
      if(this.property != null){
        this.$refs.inspector.apply();
        this.property.code = this.device.code;
        var problemlast = null;
        if(!_.isNil(this.oldproblem.id))  problemlast = {"id": this.oldproblem.id, "_destroy": true};
        this.$emit('save', {'mode': this.mode, 'property': this.property, 'problem': problemlast, 'device': this.device })
      }
      if(this.problem != null){
        this.problem.kind = this.kind;
        this.problem.inactivate_cause = this.inactivate_cause;
        this.problem.media = this.media;
        this.problem.code = this.device.code;
        var propertylast = null;
        if(!_.isNil(this.oldproperty.id))  propertylast = {"id": this.oldproperty.id, "_destroy": true};
        this.$emit('save', {'mode': this.mode, 'property': propertylast, 'problem': this.problem, 'device': this.device })
      }
      
    },
    setFile: function(doc, name, file) {
            var that = this;

            doc.image = file[0];
            var reader = new FileReader();

            reader.onload = function(event) {
                var dataUri = event.target.result;
                var img = document.getElementsByClassName('photo' + that.property.media.indexOf(doc))[0];

                img.src = dataUri;
            };
            reader.onerror = function(event) {
            };
            reader.readAsDataURL(doc.image);
            if (file.length > 1) {
                for (var i in _.range(file.length)) {
                    if (i > 0) {
                        var ndoc = { timestamp: _.now() };
                        ndoc.image = file[i];
                        var reader = new FileReader();

                        reader.onload = function(event) {
                            var dataUri = event.target.result;
                            var img = document.getElementsByClassName('photo' + that.property.media.indexOf(ndoc))[0];
                            img.src = dataUri;
                        };
                        reader.onerror = function(event) {
                        };
                        reader.readAsDataURL(ndoc.image);

                        this.property.media.push(ndoc)
                    }
                }
            }

        },
  },
  computed: {
    pestsDict(){
      return  _.toPairs(this.pestGroups).map(function(para){
        return para[1].map(function(pest){
            return {id: pest.id, name: pest.name};
          })
      });
    },
    pests(){
      return  _.toPairs(this.pestGroups).map(function(para){
        return {
          name: para[0],
          items: para[1].map(function(pest){
            return {id: pest.id, name: pest.name};
          })
        }
      });
    },
    substances(){
      return  _.toPairs(this.substanceGroups).map(function(para){
        return {
          name: para[0],
          items: para[1].map(function(substance){
            return {id: substance.id, name: substance.name, unit: substance.default_unit};
          })
        }
      });
    },
    dosesPercentage(){
      var sum = 0;
      var doseSum = 0;
      for (var i = this.property.dosages.length - 1; i >= 0; i--) {
        var dose = this.property.dosages[i];
        var dos = parseInt(dose.dosage);
        if(dos != null && dos != undefined){
          sum = sum + parseInt(dose.consumed);
          doseSum = doseSum + dos;
        }
      }
      if(doseSum == 0) return 0;
      else return (sum * 100) / doseSum;
    },
    good: {
      get: function(){
        return this.safety_conditions == 3;
      },
      set: function(newVal){
        if(newVal){
          this.safety_conditions = 3
        }
      }
    },
    broken: {
      get: function(){
        return this.safety_conditions == 2;
      },
      set: function(newVal){
        if(newVal){
          this.safety_conditions = 2
        }
      }
    },
    need_replace: {
      get: function(){
        return this.safety_conditions == 1;
      },
      set: function(newVal){
        if(newVal){
          this.safety_conditions = 1
        }
      }
    },
    safety_conditions_val: {
      get: function(){
       return ["need_replace", "broken", "good"][this.safety_conditions - 1 ]
      },
      set: function(newVal){
        this.safety_conditions = ["need_replace", "broken", "good"].indexOf(newVal) + 1
        this.$forceUpdate()
      }
    }
  }
}
</script>
<style scoped>
  select {
    display: block;
  }
  .modal{
    border: 5px solid #00CC66;
    border-radius: 15px;
  }
  h5{
    font-size: 15px;
    text-transform: uppercase;
  }
  label{
    padding: 10px;
    margin: 5px;
    border: 2px solid rgb(140, 140, 140);
    border-radius: 5px;
  }
  label:has(input:checked){
    border: 2px solid #00CC66 !important;
  }
  [type="checkbox"]+span:not(.lever):before {
      top: 0px;
      left: 0px;
      margin: 4px;
      width: 16px;
      height: 16px;
      border: 2px solid rgb(140, 140, 140);
      border-radius: 50%;
      -webkit-transform: rotate(40deg);
      transform: rotate(0deg) !important;
      -webkit-backface-visibility: hidden;
      backface-visibility: hidden;
      -webkit-transform-origin: 100% 100%;
      transform-origin: 100% 100%;
  }
  [type="checkbox"]:checked+span:not(.lever):before {
      top: 0px;
      left: 0px;
      border: 2px solid #00CC66;
      line-height: 12px;
      font-family: 'Material Icons';
      color: #00CC66;
      content: "\e5ca";
      border-radius: 50%;
      -webkit-transform: rotate(40deg);
      transform: rotate(0deg) !important;
      -webkit-backface-visibility: hidden;
      backface-visibility: hidden;
      -webkit-transform-origin: 100% 100%;
      transform-origin: 100% 100%;
      font-size: 12px;
  }
  [type="radio"]:checked+span:after{
    border: 2px solid #00CC66;
    background-color: #fff;
    font-family: 'Material Icons';
    color: #00CC66;
    content: "\e5ca";
    line-height: 12px;
    font-size: 12px;
  }
  fieldset{
    padding-top: 15px;
    padding-bottom: 15px;
    border-radius: 5px;
  }
  .removephoto {
      vertical-align: top;
      float: right;
      background-color: black;
      border: none;
      border-radius: 15px;
  }
  .removephoto i {
      color: white;
  }
</style>
